export default __webpack_public_path__ + "static/media/stomach2.8f575bab.jpg";